var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "small pb-3" }, [
      _c("p", { staticClass: "pb-2 border-bottom fw-bold" }, [
        _vm._v("Old value"),
      ]),
      _vm._v(" "),
      _c("small", [_vm._v(_vm._s(_vm.oldValue))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "small" }, [
      _c("p", { staticClass: "py-2 border-bottom border-top fw-bold" }, [
        _vm._v("New value"),
      ]),
      _vm._v(" "),
      _c("small", [_vm._v(_vm._s(_vm.newValue))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }